
import { useEffect, useContext, useState } from "react";
import { 
  View, 
  useTheme, 
  Image, 
  Text, 
  Heading, 
  useAuthenticator, 
  Authenticator, 
  Button, 
  Grid, 
  Flex 
} from '@aws-amplify/ui-react';
// import '@aws-amplify/ui-react/styles.css';
import './amplify_styles.css'
import { useNavigate, useLocation } from 'react-router';
import { GlobalContext } from "../../context";
// import { leagueId } from "../../leagueId";


export default function Login() {
  const { 
    userAttributes, setUserAttributes,
    // theme, setTheme,
    authRedirect, setAuthRedirect,
  } = useContext(GlobalContext);
  const { user, signOut, toSignIn, toSignUp, toResetPassword } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); // https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced
  const { authStatus } = useAuthenticator(context => [context.authStatus]); // https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (route === 'authenticated') {
      setUserAttributes(user.getSignInUserSession()!.getIdToken().payload)
      navigate(authRedirect)
    }
  }, [route, navigate]);

  const components = {
    Header() {
      const { tokens } = useTheme();
  
      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            alt="FRG logo"
            src="/images/frg-logo.jpg"
            style={{
              borderRadius: "10px"
            }}
          />
        </View>
      );
    },
  
    Footer() {
      const { tokens } = useTheme();
  
      return (
        <View textAlign="center" padding={tokens.space.large}>
          {/* <Button 
            onClick={() => navigate(-1)}
            variation="destructive"
            width={"100%"}
          >
            Go back
          </Button> */}
          {/* <Text color={"blue"}>
            &copy; All Rights Reserved
          </Text> */}
        </View>
      );
    },
  
    SignIn: {
      Header() {
        const { tokens } = useTheme();
  
        return (
          <></>
          // <Heading
          //   padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          //   level={3}
          // >
          //   Sign in to your account
          // </Heading>
        );
      },
      Footer() {
        const { toResetPassword } = useAuthenticator();
        const { tokens } = useTheme();
  
        return (
          <View textAlign="center" padding={tokens.space.large} marginTop={"-35px"}>
            <Button 
            onClick={() => navigate(-1)}
            variation="destructive"
            width={"100%"}
            marginTop={"-20px"}
          >
            Go back
          </Button>
            <p />
            <Button
              fontWeight="normal"
              onClick={toResetPassword}
              size="small"
              variation="link"
            >
              Reset Password
            </Button>
          </View>
        );
      },
    },
  
    SignUp: {
      Header() {
        const { tokens } = useTheme();
  
        return (
          <></>
          // <Heading
          //   padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          //   level={3}
          // >
          //   Create a new account
          // </Heading>
        );
      },
      Footer() {
        const { toSignIn } = useAuthenticator();
  
        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toSignIn}
              size="small"
              variation="link"
            >
              Back to Sign In
            </Button>
          </View>
        );
      },
    },
    ConfirmSignUp: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Confirmation Code:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
      
    },
    SetupTOTP: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Confirmation Code:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
    },
    ConfirmSignIn: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Confirmation Code:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
    },
    ResetPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Reset Password:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
    },
    ConfirmResetPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Confirmation Code:
          </Heading>
        );
      },
      Footer() {
        return <Text></Text>;
      },
    },
  };
  
  const formFields = {
    signIn: {
      username: {
        placeholder: 'Enter your username',
        order: 1,
      },
    },
    signUp: {
      username: {
        placeholder: 'Enter username',
        isRequired: false,
        order: 1,
      },
      email: {
        type: 'email',
        placeholder: 'Enter email',
        isRequired: true,
        order: 2,
      }, 
      given_name: {
        type: 'given_name',
        label: 'First name',
        placeholder: 'Enter first name',
        isRequired: true,
        order: 3,
      },
      family_name: {
        type: 'family_name',
        label: 'Last name',
        placeholder: 'Enter last name',
        isRequired: true,
        order: 4,
      },
      // birthdate: {
      //   label: 'Birthdate',
      //   isRequired: false,
      //   order: 5,
      // },
      password: {
        label: 'Password:',
        placeholder: 'Enter Password',
        isRequired: true,
        order: 10,
      },
      confirm_password: {
        label: 'Confirm Password',
        isRequired: true,
        order: 11,
      },
      league_id: {
        name: 'custom:leagueId',
        label: '',
        isRequred: true,
        // value: leagueId,
        hidden: true,
      },
      // iRacingCustomerId: {
      //   name: 'custom:iRacingCustomerId',
      //   label: 'iRacing customer ID',
      //   placeholder: '123456',
      //   isRequired: true,
      //   order: 6,
      //   hint: 'Log into iRacing to find your customer id',
      // },
      // iRacingDriverName: {
      //   name: 'custom:iRacingDriverName',
      //   label: 'iRacing driver name',
      //   isRequired: true,
      //   order: 7,
      //   hint: 'Your driver name in iRacing, including any numbers',
      // },
      // discordUserID: {
      //   name: 'custom:discordUserId',
      //   label: 'Discord user ID',
      //   placeholder: '752359355582278977',
      //   isRequired: true,
      //   order: 8,
      //   hint: 'Log into Discord to find your user id',
      // },
      // maLicenceId: {
      //   name: 'custom:maLicenceId',
      //   label: 'Motorsport Australia Licence ID',
      //   placeholder: '123456789',
      //   isRequired: false,
      //   order: 9,
      //   hint: 'Apply for an licence on the MA e-sports website',
      // },
    },
    forceNewPassword: {
      password: {
        placeholder: 'Enter your Password:',
      },
    },
    resetPassword: {
      email: {
        placeholder: 'Enter your email:',
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: 'Enter your Confirmation Code:',
        label: 'New Label',
        isRequired: false,
      },
      confirm_password: {
        placeholder: 'Enter your Password Please:',
      },
    },
    setupTOTP: {
      QR: {
        totpIssuer: 'test issuer',
        totpUsername: 'amplify_qr_test_user',
      },
      confirmation_code: {
        label: 'New Label',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: 'New Label',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
  };
  
  const socialProviders: any = [
      "google",
      // "facebook",
    ]
  
  const loginMechanisms: any = [
    "username"
  ]
  
  const signUpAttributes: any = [
    // "email",
    // "birthdate",
    // "name",
  ]
    
  return (
    <Grid templateColumns={{ base: "1fr 0", medium: "1fr 1fr" }}>
      <Flex
        backgroundColor={"whitesmoke"} 
        justifyContent="center"
        alignItems={"center"}
        height={"100vh"}
      >
        <View>
          <Authenticator
            // variation="modal"
            formFields={formFields} 
            components={components} 
            socialProviders={socialProviders}
            loginMechanisms={loginMechanisms}
            initialState="signIn"
            username-alias="email"
            // signUpAttributes={signUpAttributes}
          >
          </Authenticator>
        </View>
      </Flex>
      <Image
        src="/images/helmet-blurred-background.jpg"
        alt="img"
        width="100%"
        height="100%"
        objectFit="cover"
      />
    </Grid>
  );
}